import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DelaysContainer from '../DelaysContainer';
import DelayReportContainer from '../../containers/DelayReportContainer';
import anime from 'animejs';
import cancelIcon from '../../assets/images/x.svg';
import DataSource from '../../dao/DataSource/DataSource';

import './DelaysDropDown.scss';

const projectWithDelays = {
  project: {
    delays: { attachments: { additionalFields: ['upload', 'photo_longitude', 'photo_latitude', 'photo_taken_at'] } },
  },
};

export class DelaysDropDown extends Component {

  constructor(props) {
    super(props);
    DelaysDropDown.propTypes = {
      project: PropTypes.object.isRequired,
      dropDownFormat: PropTypes.object, //expects null or an object with top and left positions
    };

    this.state = {
      showDelaysList: props.showDelaysList,
      delay: null,
      iconSrc: null,
      displayDelayId: props.displayDelayId,
      project: null,
    };

    this.collapsePopup = this.collapsePopup.bind(this);
    this.displayReadOnly = this.displayReadOnly.bind(this);
    this.displayList = this.displayList.bind(this);
    this.handleProjectRetrieval = this.handleProjectRetrieval.bind(this);
  }

  handleProjectRetrieval(project, action) {
    if (action != 'prefetch') {
      this.setState({ project });
      this.expandPopup();
    }
  }

  componentDidMount() {
    if (this.props.project) {
      this.projectDataSource = new DataSource('Project', this.props.project.id, projectWithDelays, this.handleProjectRetrieval);
      this.projectDataSource.get();
    }
  }

  componentWillUnmount() {
    if (this.projectDataSource) {
      this.projectDataSource.release();
      this.projectDataSource = null;
    }
  }

  componentDidUpdate(prevProps) {
    const { showDelaysList } = this.props;
    if (!prevProps.project && this.props.project) {
      this.projectDataSource = new DataSource('Project', this.props.project.id, projectWithDelays, this.handleProjectRetrieval);
      this.projectDataSource.get();
    }

      //so parent can have control over going back to display list, take out when implement action cable
    if (prevProps.displayDelayId != this.props.displayDelayId && this.props.displayDelayId) {
      this.setState({ displayDelayId: this.props.displayDelayId, showDelaysList: false });
    }
    else if (prevProps.showDelaysList != showDelaysList && showDelaysList == true) {
      this.displayList();
    }
  }

  expandPopup() {
    return anime({
      targets: '.delays-drop-down',
      height: 400,
      easing: 'easeInOutCubic',
      duration: 200,
    });
  }

  collapsePopup(e) {
    e.stopPropagation();
    return anime({
      targets: '.delays-drop-down',
      height: 0,
      easing: 'easeInOutCubic',
      duration: 200,
      complete: () => {
        this.props.closeDropDown();
      },
    });
  }

  displayList(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    this.setState({ showDelaysList: true, delay: null, iconSrc: null });
    if (this.props.trackDisplayList) {
      this.props.trackDisplayList(true);
    }
  }

  displayReadOnly(delay, iconSrc) {
    this.setState({ showDelaysList: false, delay, iconSrc });
    if (this.props.trackDisplayList) {
      this.props.trackDisplayList(false);
    }
  }

  render() {
    const { dropDownFormat } = this.props;
    const { showDelaysList, project } = this.state;

    const top = dropDownFormat ? dropDownFormat.top + 6 : null;
    const style = { top };

    if (!project) {
      return null;
    }

    const tabContent = showDelaysList
      ? <DelaysContainer
          project={this.state.project}
          displayReadOnly={this.displayReadOnly}
        />
      : <DelayReportContainer 
        delay={this.state.delay} 
        displayDelayId={this.state.displayDelayId}
          iconSrc={this.state.iconSrc}
          carouselPosition={'absolute'}
          carouselWidth={312}
          carouselHeight={'100%'}
          carouselTop={1}
          carouselBorderRadius={true}
        />;

    return (
      <div 
        className='delays-drop-down' 
        style={style}
        ref={el => this.remainingPopout = el}
      >
        <div className='delays-header'>
          {!showDelaysList && <a href='' onClick={this.displayList}>BACK</a> }
          <img 
            src={cancelIcon} 
            alt='exit drop down' 
            onClick={this.collapsePopup}
          />
          <h1>{ showDelaysList ? 'REPORTED DELAYS' : 'REPORTED DELAY' }</h1>
        </div>
        { tabContent }
      </div>
    );
  }

}

export default DelaysDropDown;



// WEBPACK FOOTER //
// ./src/components/DelaysDropDown/index.js